// Legacy inline-style constants — kept so non-migrated components (ExitSection,
// RiskSection, ChannelSection, etc.) still render correctly while we move them to
// shadcn/Tailwind incrementally. Every color now references the CSS variables
// defined in src/index.css so dark/light mode toggles flow through automatically.
//
// New components SHOULD use Tailwind classes + shadcn primitives instead.

import type { CSSProperties } from "react";

export const COLORS = {
  bgDeepest: "var(--background)",
  bgPanel: "var(--card)",
  bgRaised: "var(--card-elevated)",
  bgInteractive: "var(--secondary)",
  border: "var(--border)",
  borderEmphasis: "var(--border)",
  text: "var(--foreground)",
  textMuted: "var(--muted-foreground)",
  accentBlue: "var(--primary)",
  green: "var(--primary)",
  greenEmphasis: "var(--primary)",
  red: "var(--destructive)",
  redEmphasis: "var(--destructive)",
  amber: "#d29922",
} as const;

export const panel: CSSProperties = {
  background: COLORS.bgPanel,
  border: `1px solid ${COLORS.border}`,
  borderRadius: 8,
  padding: 20,
};

export const input: CSSProperties = {
  width: "100%",
  padding: "8px 10px",
  background: COLORS.bgPanel,
  color: COLORS.text,
  border: `1px solid ${COLORS.border}`,
  borderRadius: 6,
  boxSizing: "border-box",
  font: "inherit",
  fontSize: 13,
};

export const button: CSSProperties = {
  padding: "6px 14px",
  background: COLORS.bgInteractive,
  color: COLORS.text,
  border: `1px solid ${COLORS.border}`,
  borderRadius: 6,
  cursor: "pointer",
  fontSize: 13,
};

export const primaryButton: CSSProperties = {
  ...button,
  background: COLORS.green,
  color: "var(--primary-foreground)",
  borderColor: COLORS.green,
  fontWeight: 600,
};

export const dangerButton: CSSProperties = {
  ...button,
  background: COLORS.red,
  color: "var(--destructive-foreground)",
  borderColor: COLORS.red,
};

export const fieldLabel: CSSProperties = {
  fontSize: 11,
  color: COLORS.textMuted,
  marginBottom: 4,
  fontWeight: 500,
};

export const sectionTitle: CSSProperties = {
  margin: 0,
  fontSize: 15,
  fontWeight: 600,
  letterSpacing: "-0.01em",
};
